import React from 'react';
import { Spinner } from 'react-bootstrap';
import { dateFormatWithTimeOptions } from '../../common/dateFormatterConfig';
import { CustomerContactPerson } from 'models/contact-person';
import { CustomerRole, CustomerRoleTranslations } from 'models/customer';

interface CustomerContactsTableProps {
    customerContacts: CustomerContactPerson[] | null;
    isRequesting: boolean;
    onEdit: (contact: CustomerContactPerson) => void;
    onDelete: (contact: CustomerContactPerson) => void;
    currentContactId?: number;
}

export function CustomerContactsTable(props: CustomerContactsTableProps) {
    const customerContacts = props.customerContacts ? props.customerContacts : [];

    const getRole = (contact: CustomerContactPerson) => {
        if (contact.representative) return CustomerRoleTranslations[CustomerRole.REPRESENTATIVE];
        if (contact.webAdmin) return CustomerRoleTranslations[CustomerRole.WEB_ADMIN];
        return CustomerRoleTranslations[CustomerRole.WEB_ACCESS];
    }

    const customerContactsTableRow = customerContacts.map((customerContact: CustomerContactPerson) => {
        const role = getRole(customerContact);

        return (
            <tr key={'row-' + customerContact.id}>
                <td>
                    { customerContact.contactName }
                </td>
                <td>
                    { customerContact.personalIdentificationCode }
                </td>
                <td>
                    { role }
                </td>
                <td>
                    { customerContact.createdByName === 'SYSTEM' ? 'Süsteem' : customerContact.createdByName }
                </td>
                <td>
                    { new Intl.DateTimeFormat('et', dateFormatWithTimeOptions).format(new Date(customerContact.dateCreated)) }
                </td>
                <td>
                    { customerContact.modifiedByName }
                </td>
                <td>
                    { customerContact.dateModified ? new Intl.DateTimeFormat('et', dateFormatWithTimeOptions).format(new Date(customerContact.dateModified)) : null }
                </td>
                <td>
                    {
                        !!props.currentContactId && customerContact.id !== props.currentContactId ? (
                            <div className="row__actions">
                                <div className='icon__edit action-icon' onClick={() => props.onEdit(customerContact)} />
                                <div className='icon__delete action-icon' onClick={() => props.onDelete(customerContact)} />
                            </div>
                        ) : null
                    }
                </td>
            </tr>
        )
        }
    );
    return (
        <div className="table__container scroll-icon-md">
            <table className='customer-applications__table table table-responsive-md table-hover'>
                <thead>
                    <tr>
                        <th>Nimi</th>
                        <th>Isikukood</th>
                        <th>Roll</th>
                        <th>Lisaja</th>
                        <th>Lisatud</th>
                        <th>Muutja</th>
                        <th>Muudetud</th>
                        <th>Tegevused</th>
                    </tr>
                </thead>
                <tbody>
                {props.isRequesting ?
                <tr>
                    <td colSpan={7}>
                        <div className="p-4 w-100 d-flex align-items-center justify-content-center">
                            <Spinner animation="grow" />
                        </div>
                    </td>
                </tr> :
                    customerContactsTableRow}
                </tbody>
            </table>
        </div>
    )
}